import React from "react";
import CTE from "../Constants";
import ChatOptionsModal from "../ChatOptions/ChatOptionsModal";
import MapWidget from "../MapWidget/MapWidget";
import ItemsCarouselWidget from "../ItemsCarouselWidget/ItemsCarouselWidget";
import AttachmentWidget from "../Attachment/AttachmentWidget";
import { Image } from "antd";
import { useTranslation } from "react-i18next";
function ChatWidget(props) {
    const { t } = useTranslation();
    switch (props.message.contentType) {
        case CTE.CONTENT_TYPE.MAP:
            return (
                <MapWidget
                    mapKey={props.mapKey}
                    language={props.language}
                    selectLocationCb={
                        props.interactionCb
                            ? props.interactionCb
                            : () => console.log("Location selected")
                    }
                    defaultLocation={{
                        lat: props.message.widgetOptions && props.message.widgetOptions.defaultLat,
                        lng: props.message.widgetOptions && props.message.widgetOptions.defaultLng,
                    }}
                    text={props.message.widgetOptions && props.message.widgetOptions.labelText}
                />
            );
        case CTE.CONTENT_TYPE.OPTIONS:
            if (props.message.widgetOptions && props.message.widgetOptions.showInChat) {
                return (
                    <ChatOptionsModal
                        interactionCb={
                            props.interactionCb
                                ? props.interactionCb
                                : () => console.log("Option selected")
                        }
                        options={props.message.options}
                        text={props.message.widgetOptions && props.message.widgetOptions.labelText}
                        language={props.language}
                    />
                );
            } else {
                return null;
            }
        case CTE.CONTENT_TYPE.ATTACHMENT:
            return (
                <AttachmentWidget
                    language={props.language}
                    selectFileCb={
                        props.selectFileCb ? props.selectFileCb : () => console.log("File selected")
                    }
                    text={props.message.widgetOptions && props.message.widgetOptions.labelText}
                />
            );
        case CTE.CONTENT_TYPE.ITEMS_CAROUSEL_MESSAGE:
            return (
                <ItemsCarouselWidget
                    selectItemsCarouselCb={
                        props.interactionCb
                            ? props.interactionCb
                            : () => console.log("Items carousel selected")
                    }
                    label={props.message.label}
                    options={props.message.options}
                    baseUrl={props.message.baseUrl}
                    language={props.language}
                />
            );
        case CTE.CONTENT_TYPE.IMAGE:
            return (
                <div
                    className={`chat-balloon__attachment ${
                        props.message.text.length === 0 && "chat-balloon__attachment--only"
                    }`}
                >
                    <Image src={props.message.fileName} />
                </div>
            );
        case CTE.CONTENT_TYPE.VIDEO:
            return (
                <div
                    className={`chat-balloon__attachment ${
                        props.message.text.length === 0 && "chat-balloon__attachment--only"
                    }`}
                >
                    <video width="100%" height="auto" controls>
                        <source src={props.message.fileName} />
                    </video>
                </div>
            );
        case CTE.CONTENT_TYPE.AUDIO:
            return (
                <div
                    className={`chat-balloon__attachment ${
                        props.message.text?.length === 0 && "chat-balloon__attachment--only"
                    }`}
                >
                    <audio controls>
                        <source src={props.message.fileName} />
                    </audio>
                </div>
            );
        case CTE.CONTENT_TYPE.DOCUMENT:
            return (
                <a href={props.message.fileName} target="_blank" rel="noopener noreferrer">
                    {props.message.text ? props.message.text : t("clickToSeeDocument")}
                </a>
            );
        default:
            return null;
    }
}
export default ChatWidget;
